import { Component, OnInit, Input, Output, EventEmitter } from "@angular/core";
import { CompsDataService } from "src/app/comps-page/comps-data.service";
import { AppService } from "src/app/app.service";
import { ComparativeAnalysisService } from "src/app/comparative-analysis/comparative-analysis.service";
import { NzMessageService } from "ng-zorro-antd/message";
import {
  VAIconRegistryService,
  close,
  plus,
  exclamationTriangle,
} from "@va/core-library/icons";
import { Subscription } from "rxjs";

@Component({
  selector: "app-comparative-ticker-modal",
  templateUrl: "./comparative-ticker-modal.component.html",
  styleUrls: ["./comparative-ticker-modal.component.scss"],
})
export class ComparativeTickerModalComponent implements OnInit {
  @Input() addRowTableData: Array<any>;
  @Input() suggestedPeers;
  @Input() recentlyVisitedCompanies;
  @Input() watchlistName;
  @Input() mpt: number;
  @Input() maxHeight: string;
  @Input() type: string;
  @Input() mptApplicable = true;
  @Output() tickerUpdate = new EventEmitter();
  @Output() mptUpdate = new EventEmitter();
  @Input() isTickerTypeBg = false;
  @Input() maxTickers: number;
  @Input() watchlistData;
  @Input() industryData;
  @Input() marketGeoData;
  @Input() isCreateNewModalIndustryMenu: boolean = false;
  @Input() showSaveWatchList: boolean = true;
  @Input() menuList = [
    {
      id: "suggested_peers",
      label: "Suggested Peers",
      isLeaf: true,
      dataProperty: "suggestedMenuData",
      disabeld: false,
    },
    {
      id: "recently_visited",
      label: "Recently Visited",
      isLeaf: true,
      dataProperty: "recentlyVisitedMenuData",
      disabled: false,
    },
    {
      id: "industry",
      label: "Industry Peers",
      dataProperty: "industryMenuData",
    },
    {
      id: "watchlist",
      label: "Watchlists",
      isLeaf: false,
      dataProperty: "watchlistMenuData",
    },
  ];

  // watchlisNameInput = "";
  watchlistError = "";
  existingWalichists;
  selectedTickers: Array<any> = [];
  recentlyVisited: Array<any> = [];
  modalData: Array<any> = [];
  stdLineItems: Array<any> = [];
  leftSectionTickerData: { company_info: Array<any>; watchername: string };
  // suggestedPeers: any;
  // recentlyVisitedCompanies: any;
  legacyUrl = `${window.caUrl}/app`;
  visible: boolean;
  selectedMenuItem = "";
  lineItems: Array<any> = [];
  allItems: Array<any> = [];
  saveWatchlist: boolean = false;
  // recentCompanies: Array<any> = [];
  isLoading = false;
  mptList = {
    1: "Industrial & commercial",
    2: "Banking & Financial Services",
    3: "Insurance",
  };

  // Subscriber
  comparativeAnalysisMenuSubscriber: Subscription;

  constructor(
    private dataService: CompsDataService,
    private message: NzMessageService,
    private appService: AppService,
    private iconRegistry: VAIconRegistryService,
    private comparativeAnalysisService: ComparativeAnalysisService,
  ) {
    this.iconRegistry.registerIcons([plus, close, exclamationTriangle]);
  }

  ngOnInit() {
    this.modalData = this.addRowTableData
      ? this.addRowTableData.map((item) => ({
          ...item,
          name: item.full_name || item.name,
          company_id: item.companyid || item.company_id || item.cid,
        }))
      : [];
    // this.getTickerData();
    this.leftSectionTickerData =
      this.suggestedPeers &&
      this.suggestedPeers["company_info"] &&
      this.suggestedPeers["company_info"].length
        ? this.suggestedPeers
        : this.recentlyVisited && this.recentlyVisited["company_info"]
          ? this.recentlyVisited
          : this.recentlyVisitedCompanies;

    this.syncSelection();
  }

  // getTickerData() {
  //   const apiCalls = [this.dataService.getRecentlyVisitedCompanies()];
  //   const rowTickers = this.addRowTableData.map((item) => {
  //     return item.ticker;
  //   });

  //   if (rowTickers && rowTickers.length) {
  //     const totalTickerLength = rowTickers.length || 0;
  //     const firstTenTickers = rowTickers.slice(0, 10);
  //     const firstTenTickersLength = firstTenTickers.length || 0;
  //     const limit = totalTickerLength - firstTenTickersLength + 10;
  //     apiCalls.push(
  //       this.dataService.getCompanyPeers(firstTenTickers, null, limit),
  //     );
  //   }
  //   forkJoin(apiCalls).subscribe((res) => {
  //     console.log({res});

  //     // this.store.dispatch(new SetDisableActions(false));
  //     if (res[0] && res[0].status === "success") {
  //       this.recentlyVisitedCompanies = this.appService.cloneArray(
  //         res[0].data,
  //       );
  //     }
  //     console.log("this.recentlyVisitedCompanies:", this.recentlyVisitedCompanies);

  //     const recentViewCompanies = this.recentlyVisitedCompanies.map((el) => {
  //       const company = {
  //         name: el.name,
  //         ticker: el.ticker,
  //         sli_comps_id: 0,
  //         mpt: el.mpt,
  //         isSelected: false,
  //       };
  //       return company;
  //     });

  //     if (res[1] && res[1].status === "success") {
  //       const responsePeers =
  //         (res[1].peer_info || []).reduce(function (result, item) {
  //           const checkIfSuggestedTickerAlreadyExists = rowTickers.includes(
  //             item.ticker,
  //           );
  //           if (!checkIfSuggestedTickerAlreadyExists) {
  //             const updatedTicker = { ...item, full_name: item.name };
  //             result.push(updatedTicker);
  //           }
  //           return result;
  //         }, []) || [];

  //       this.suggestedPeers = responsePeers.slice(0, 10);
  //     }

  //     const recentViewCompany = {
  //       watchername: "Recently viewed (up to 30)",
  //       company_info: recentViewCompanies,
  //     };

  //     this.recentlyVisitedCompanies = recentViewCompany;

  //     const suggestedPeerCompanies = this.suggestedPeers.map((pc) => {
  //       const company = {
  //         name: pc.name,
  //         ticker: pc.ticker,
  //         sli_comps_id: 0,
  //         mpt: pc.mpt,
  //         isSelected: false,
  //       };
  //       return company;
  //     });
  //     const suggestedPeerData = {
  //       watchername: "Suggested Peers",
  //       company_info: suggestedPeerCompanies,
  //     };

  //     this.suggestedPeers = suggestedPeerData
  //     console.log("this.recentlyVisitedCompanies: ", this.recentlyVisitedCompanies, "\nthis.suggestedPeers:", this.suggestedPeers);
  //     this.leftSectionTickerData = this.recentlyVisitedCompanies;
  //     this.syncSelection()
  //   });

  // }

  addTicker(params) {
    if (this.modalData.length === 0 && this.mpt === null) {
      this.mpt = params[0].mpt;
      this.mptUpdate.emit(this.mpt);
    }
    const tickerExist = this.modalData.filter((data) => {
      return data.ticker === params[0].ticker;
    });
    // const mpt = params[0].mpt;

    if (tickerExist.length === 0) {
      // for (let i = 0; i < this.leftSectionTickerData.length; i++) {
      this.leftSectionTickerData["company_info"].map((el) => {
        if (params[0].ticker === el.ticker) {
          el.isSelected = true;
        }
        return el;
      });
      // }
      params[0].isSelected = true;
      if (!params[0].full_name) {
        params[0]["full_name"] = params[0].name || params[0].full_name;
      }
      this.modalData.push(params[0]);
      this.tickerUpdate.emit(this.modalData);
    }

    // if (!this.mptApplicable || mpt === this.mpt) {
    //   if (tickerExist.length === 0) {
    //     // for (let i = 0; i < this.leftSectionTickerData.length; i++) {
    //     this.leftSectionTickerData["company_info"].map((el) => {
    //       if (params[0].ticker === el.ticker) {
    //         el.isSelected = true;
    //       }
    //       return el;
    //     });
    //     // }
    //     params[0].isSelected = true;
    //     this.modalData.push(params[0]);
    //     this.tickerUpdate.emit(this.modalData);
    //   }
    // } else {
    //   this.message.create(
    //     "error",
    //     `Error: We currently cannot create a peer analysis table with tickers from BOTH ${
    //       this.mptList[this.mpt]
    //     } and ${this.mptList[mpt]} sectors.`,
    //   );
    // }
  }

  onWatchlistSelect(e, d) {
    this.selectedMenuItem = d.watchername;
    this.recentlyVisited = d.company_info;
  }

  onMenuVisibleChange(visible) {
    this.visible = visible;
  }

  addSearchedTicker(tickerInfo): void {
    if (this.modalData.length === 0 && this.mpt === null) {
      this.mpt = tickerInfo.mpt;
      this.mptUpdate.emit(this.mpt);
    }
    const ticker = this.isTickerTypeBg ? tickerInfo.bTicker : tickerInfo.ticker;
    const company = {};
    company["full_name"] = tickerInfo.full_name || tickerInfo.name;
    company["name"] = tickerInfo.full_name || tickerInfo.name;
    company["sli_comps_id"] = 0;
    company["ticker"] = ticker;
    company["mpt"] = tickerInfo.mpt;
    company["isSelected"] = true;
    company["cid"] = tickerInfo.cid;
    // const mpt = tickerInfo.mpt;

    const tickerExist = this.modalData.filter((data) => {
      return data.ticker === ticker;
    });
    if (tickerExist.length === 0) {
      this.addTicker([company, false]);
    } else {
      this.message.create("info", "This ticker is already present.");
    }

    // if (!this.mptApplicable || this.mpt === mpt) {
    //   const tickerExist = this.modalData.filter((data) => {
    //     return data.ticker === ticker;
    //   });
    //   if (tickerExist.length === 0) {
    //     this.addTicker([company, false]);
    //   } else {
    //     this.message.create("info", "This ticker is already present.");
    //   }
    // } else {
    //   this.message.create(
    //     "error",
    //     `Error: We currently cannot create a peer analysis table with tickers from BOTH ${
    //       this.mptList[this.mpt]
    //     } and ${this.mptList[mpt]} sectors.`,
    //   );
    // }
  }

  removeTicker(company) {
    // if(company.sli_comps_id){
    // for (let i = 0; i < this.watchlistData.length; i++) {
    this.leftSectionTickerData &&
      this.leftSectionTickerData["company_info"] &&
      this.leftSectionTickerData["company_info"].map((el) => {
        if (company.ticker === el.ticker) {
          el.isSelected = false;
        }
        return el;
      });
    // }
    //}
    // else{
    //   company.isSelected = false;
    // }
    //company.isSelected = false;

    const index = this.modalData.indexOf(company);
    this.modalData.splice(index, 1);
    if (this.modalData.length < 1) {
      this.mpt = null;
    }
    this.tickerUpdate.emit(this.modalData);
  }

  addAllTickers() {
    // const err = false;
    const len =
      this.leftSectionTickerData && this.leftSectionTickerData["company_info"]
        ? this.leftSectionTickerData["company_info"].length
        : 0;
    for (let i = 0; i < len; i++) {
      const company = this.leftSectionTickerData["company_info"][i];
      this.addTicker([company, false]);
    }
    // for (let i = 0; i < len; i++) {
    //   const company = this.leftSectionTickerData["company_info"][i];
    //   if (company.mpt === this.mpt || this.mpt === null || !this.mptApplicable)
    //     this.addTicker([company, false]);
    //   else {
    //     err = true;
    //   }
    // }
    // if (err) {
    //   this.message.create(
    //     "error",
    //     `Error: We currently cannot create a peer analysis table with Tickers across Industrial & Commercial, Banking & Financial Services, and Insurance sectors.`,
    //   );
    // }
  }

  removeAllTickers() {
    this.mpt = null;
    this.modalData = this.modalData.filter((item) => item.tickerDeleteDisabled);
    this.tickerUpdate.emit(this.modalData);

    this.leftSectionTickerData["company_info"].map((el) => {
      // let obj = Object.assign({}, el);
      el.isSelected = false;
      return el;
    });
    this.suggestedPeers["company_info"].map((el) => {
      el.isSelected = false;
      return el;
    });
    this.recentlyVisitedCompanies["company_info"].map((el) => {
      el.isSelected = false;
      return el;
    });
    // Need to make sure that company in left section is synced with selection in right section
  }

  // For Industry and Watchlists
  handleMenuApply(data) {
    const isWatchlistMenuType = data.watchlist_id;
    if (isWatchlistMenuType) {
      this.comparativeAnalysisMenuSubscriber = this.comparativeAnalysisService
        .fetchCompaniesList(data)
        .subscribe((response) => {
          if (response.status === "success") {
            this.leftSectionTickerData = {
              company_info: response.ticker_info,
              watchername: "Watchlist",
            };
            this.syncSelection();
          }
        });
    } else {
      this.leftSectionTickerData = {
        company_info: data.ticker_info,
        watchername: "Industry",
      };
      this.syncSelection();
    }
  }

  // For Suggested Peers and Recently Visited
  handleMenuItemChange(data) {
    if (data.id === "suggested_peers") {
      this.leftSectionTickerData = this.suggestedPeers;
    } else if (data.id === "recently_visited") {
      this.leftSectionTickerData = this.recentlyVisitedCompanies;
    }

    this.syncSelection();
  }

  syncSelection() {
    this.leftSectionTickerData &&
      this.leftSectionTickerData["company_info"] &&
      this.leftSectionTickerData["company_info"].forEach((el) => {
        let selectedFlag = false;
        this.modalData.forEach((item) => {
          if (el.ticker === item.ticker) {
            el.isSelected = true;
            selectedFlag = true;
          }
        });
        if (!selectedFlag) {
          el.isSelected = false;
        }
      });
  }

  validateWatchlistName() {
    if (this.saveWatchlist) {
      if (!this.watchlistName || this.watchlistName.trim() === "") {
        this.watchlistError = "Watchlist Name cannot be blank.";
      } else {
        const currentWatchlistName = this.watchlistName.trim().toLowerCase();
        let nameExist = false;
        for (const item of this.watchlistData) {
          if (item.label.trim().toLowerCase() === currentWatchlistName) {
            this.watchlistError =
              "Name already exists. Please enter a different one. ";
            nameExist = true;
            break;
          }
        }
        if (!nameExist) {
          this.watchlistError = "";
        }
      }
    } else {
      this.watchlistError = "";
    }
  }
}
